import { ReactElement } from 'react'

import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import { Icon } from 'components/core'
import { Field } from 'types'

interface Props<RecordType> {
    updateColumns: (columns: Field<RecordType>[]) => void
    columns: Field<RecordType>[]
    parentId: string
    isCollapsed: boolean
    showVerticalLine?: boolean
}

function ToggleMetricDeltasTitle<RecordType>({
    updateColumns,
    columns,
    parentId,
    isCollapsed,
}: Props<RecordType>): ReactElement {
    const { t } = useTranslation('table')

    const toggleChildrenColumnsVisible = (): void => {
        const updatedColumns = columns.map((column) => {
            if (column.id === parentId) {
                return {
                    ...column,
                    childrenFields: column?.childrenFields?.map((child) => ({
                        ...child,
                        isVisible: !child.isVisible,
                    })),
                }
            }
            return column
        })

        updateColumns(updatedColumns)
    }

    return (
        <div>
            <Tooltip
                title={
                    isCollapsed
                        ? t(
                              'table:PeriodDeltas.tooltipTitle.show',
                              'Show Change Columns'
                          )
                        : t(
                              'table:PeriodDeltas.tooltipTitle.hide',
                              'Hide Change Columns'
                          )
                }
                arrow={{ pointAtCenter: true }}
                placement="top"
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Button size="small" onClick={toggleChildrenColumnsVisible}>
                        <Icon
                            name="EXPAND"
                            rotate={45}
                            margin="0 2px"
                            color="blackAlpha50"
                        />
                    </Button>
                </div>
            </Tooltip>
        </div>
    )
}

export default ToggleMetricDeltasTitle
